import { createSelector } from 'reselect'

import { isPromoValid } from '@/utils'

import type { PromoResponse, PromoState } from './types'

export const promoSelector = createSelector(
    (state: PromoState) => state.data,
    (data: PromoResponse | undefined) => (isPromoValid(data) ? data : undefined),
)
